/** E.164 without spaces: leading +, 11 to 15 digits. */
const E164_PHONE = /^\+[1-9]\d{10,14}$/;

export function isE164Phone(value: string): boolean {
  return E164_PHONE.test(value);
}

/**
 * Appends one keypad digit to an international number.
 * A 0 typed right after the dial code is the national trunk prefix and is dropped,
 * so 0780234556 with +33 becomes +33780234556.
 */
export function appendE164Digit(phone: string, digit: number, dialCode: string): string {
  const prefix = dialCode.startsWith('+') ? dialCode : `+${dialCode}`;
  let next = `${phone}${digit}`.replace(/[^\d+]/g, '');
  if (prefix && next.startsWith(`${prefix}0`)) {
    next = prefix + next.slice(prefix.length + 1);
  }
  const digitCount = next.replace(/\D/g, '').length;
  if (digitCount > 15) {
    return phone;
  }
  return next;
}
